import React from 'react';
import { connect } from 'react-redux';

import FaqsSection from 'dpl/join_as_breeder/components/FaqsSection';

function FaqsSectionContainer(props) {
  return <FaqsSection {...props} />;
}

export default connect(({ server }) => ({
  faqItems: server.faqItems
}))(FaqsSectionContainer);
